import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver } from 'src/app/core/resolvers';

export const cecRoutes: Routes = [
  {
    path: 'cec',
    title: 'WEB_LOGIN_CEC',
    resolve: {
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/cec.component').then(
        (m) => m.CommunityEmergencyCodeComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.CEC },
  },
];
